import { hasUnmetBookabilityCriteria } from "../OpenShifts/ShiftAction/hasUnmetBookabilityCriteria";
import {
  type BookabilityStatusItem,
  BookabilityUnmetCriteria,
} from "../OpenShifts/ShiftAction/types";
import { useSkillsAssessmentFeatureFlags } from "./api/useSkillsAssessmentFeatureFlags";

export function useShouldShowBlockingSkillsAssessmentBookability(
  bookabilityStatus: BookabilityStatusItem | undefined
): boolean {
  const { isClipboardOrientationEnabled } = useSkillsAssessmentFeatureFlags();

  return (
    hasUnmetBookabilityCriteria(bookabilityStatus, [
      BookabilityUnmetCriteria.WORKER_HAS_NOT_PASSED_ASSESSMENTS,
    ]) && !isClipboardOrientationEnabled
  );
}
